/**
 * RefreshButton — jednotne tlacitko pro obnoveni dat.
 * Vzdy jen ikona sipek (RefreshCw), zadny text.
 * Tri velikosti podle kontextu.
 *
 * Pouziti:
 *   <RefreshButton onRefresh={refetch} />                  // sm (default, v kartach)
 *   <RefreshButton onRefresh={refetch} size='md' />        // md (v headerech sekci)
 *   <RefreshButton onRefresh={refetch} size='lg' />        // lg (hlavni akce stranky)
 *   <RefreshButton onRefresh={refetch} loading={fetching} /> // animace pri nacitani
 */
import { RefreshCw } from 'lucide-react';
import { Button } from './Button';

const ICON_SIZE = { sm: 12, md: 14, lg: 16 } as const;

interface RefreshButtonProps {
  onRefresh: () => void;
  loading?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function RefreshButton(
  { onRefresh, loading = false, size = 'sm', className }: RefreshButtonProps,
) {
  return (
    <Button
      variant='ghost'
      size='icon'
      onClick={onRefresh}
      loading={loading}
      icon={!loading ? <RefreshCw size={ICON_SIZE[size]} /> : undefined}
      title='Obnovit'
      className={className}
    />
  );
}
